module.exports = __webpack_public_path__ + "static/media/potluck-invite-sidebar.b3dce8b0.svg";